<template>
  <q-drawer
    :width="260"
    show-if-above
    v-model="this.model"
    side="left"
    class="menu navbarMenu"
  >
    <q-linear-progress v-if="this.loading" indeterminate />
    <div class="menu__header">
      <div class="menu__logo">
        <router-link to="/" class="menu__logo_link">
          <img
            v-if="this.system === 'sbs'"
            src="@/assets/img/logo_sbs_blue.svg"
            style="height: 22px;"
            alt="menu_logo"
          />
          <img v-else src="@/assets/img/logo.svg" alt="menu_logo" />
        </router-link>
        <q-btn
          dense
          flat
          class="menu__toggle"
          icon="fa-solid fa-angles-left"
          aria-label="Скрыть меню"
          title="Скрыть меню"
          @click.prevent="$emit('toggle-navbar')"
        />
      </div>
      <div class="menu__flex">
        <CityBlock />
        <CompaniesBlock />
      </div>
    </div>
    <div class="menu__search">
      <CustomInput
        :value="this.searchTerm"
        :isSearch="true"
        placeholder="Поиск по меню"
        v-debounce:300="this.onSearchChange"
      />
    </div>
    <div class="menu__list">
      <menu-list :menu="this.menus" :expand-all="!!this.searchTerm" />
    </div>
  </q-drawer>
</template>
<script>
import MenuList from './MenuList'
import {getMenuData, searchMenuByName} from "@/components/layout/Navbar/services";
import CityBlock from "@/components/features/cityBlock";
import CompaniesBlock from "@/components/features/companiesBlock";
import CustomInput from "@/components/form/CustomInput";
import { LOCALSTORAGEFIELDS } from '@/constants';
import { getSystemCode } from '@/services';

export default {
  props: ["value"],
  name: "Navbar",
  components: {CompaniesBlock, CityBlock, MenuList, CustomInput},
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("navbar_change", newValue);
      },
    },
    menus() {
      if(!this.searchTerm) return this.menu
      return searchMenuByName(this.menu, this.searchTerm)
    }
  },
  methods: {
    onSearchChange(value) {
      this.searchTerm = value
    },
  },
  async mounted() {
    this.loading = true
    this.menu = await getMenuData()
    this.loading = false
  },
  data() {
    return {
      menu: [],
      loading: false,
      searchTerm: '',
      system: getSystemCode()
    };
  },
};
</script>

<style lang="scss">
// Светлая голубоватая панель меню (цвета — --ms-nav-* в theme.scss).
.q-drawer__content.navbarMenu {
  background: var(--ms-nav-bg);
  border-right: 1px solid var(--ms-nav-border);
  color: var(--ms-nav-text);
  font-family: var(--ms-nav-font);
  scrollbar-width: none;

  // Поиск по меню — белое поле на голубом фоне
  .menu__search .q-field--outlined .q-field__control {
    background: var(--ms-surface);
    border-radius: 10px;

    &::before {
      border-color: var(--ms-nav-border) !important;
      border-radius: 10px;
    }
  }

  .menu__search .q-field__native,
  .menu__search .q-field__input {
    color: var(--ms-nav-text-strong);
  }

  .menu__search .q-field__native::placeholder {
    color: var(--ms-nav-icon);
  }

  .menu__search .q-field__append .q-icon {
    color: var(--ms-nav-icon);
  }

  // Город и компания (на телефоне показываются здесь)
  .ms-pill {
    background: var(--ms-surface);
    border-color: var(--ms-nav-border);
    color: var(--ms-nav-text-strong);
  }

  .ms-pill__icon {
    color: var(--ms-primary);
  }

  .ms-pill__chevron {
    color: var(--ms-nav-icon);
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
</style>
<style scoped lang="scss">
// Меню на всю высоту, логотип и «свернуть» сверху на высоте хедера, ниже поиск (вид пунктов — в MenuList.vue).
.menu {

  &__flex {
    display: none;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px 0;

    @media (max-width: 576px) {
      display: flex;
    }
  }

  &__logo {
    height: var(--ms-header-h);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 0 12px 0 20px;
    border-bottom: 1px solid var(--ms-nav-line);

    &_link {
      display: flex;
      align-items: center;

      img {
        height: 30px;
      }
    }
  }

  &__search {
    padding: 10px 12px 4px;
  }

  &__toggle {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: var(--ms-radius-sm);
    border: 1px solid var(--ms-nav-border);
    background: var(--ms-surface);
    color: var(--ms-nav-text-sub);
    font-size: 11px;

    &:hover {
      border-color: var(--ms-primary);
      color: var(--ms-primary);
    }
  }

  &__list {
    padding: 6px 10px 16px;
  }
}
</style>
